import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["authorizationCheckbox", "authorizationIds", "totalSelectedAmount", "footer", "approveAllCheckbox"]

  connect() {
    this.updateDisplay()
  }

  toggleCheckbox(e) {
    const qbBillId = e.target.getAttribute("data-qb-bill-id")
    
    // Find all checkboxes with the same qb_bill_id
    const relatedCheckboxes = this.authorizationCheckboxTargets
      .filter(checkbox => checkbox.getAttribute("data-qb-bill-id") == qbBillId)
    
    // Set all related checkboxes to the same state as the clicked one
    relatedCheckboxes.forEach(checkbox => {
      checkbox.checked = e.target.checked
    })
    
    this.updateDisplay()
  }

  toggleApproveAll(e) {
    const isChecked = e.target.checked
    
    // Set all authorization checkboxes to the same state as the approve all checkbox
    this.authorizationCheckboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    
    this.updateDisplay()
  }

  updateDisplay() {
    const checkedBoxes = this.authorizationCheckboxTargets.filter(checkbox => checkbox.checked)
    const selectedIds = checkedBoxes.map(checkbox => checkbox.dataset.authorizationId)
    
    // Update hidden field with selected IDs
    this.authorizationIdsTarget.value = JSON.stringify(selectedIds)
    
    // Calculate total amount
    let totalAmount = 0
    checkedBoxes.forEach(checkbox => {
      const amount = parseFloat(checkbox.dataset.paymentAmount) || 0
      totalAmount += amount
    })
    
    // Update total display
    this.totalSelectedAmountTarget.textContent = this.formatCurrency(totalAmount)
    
    // Show/hide footer based on selection
    if (checkedBoxes.length > 0) {
      this.footerTarget.style.display = ""
    } else {
      this.footerTarget.style.display = "none"
    }
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount)
  }
}